import base, { ApiTag } from './base';
import View from '@enview/interface/types/View';

interface CreateViewParams {
  orgId: number;
  name: string;
  description?: string;
  tagId?: number;
  searchCriteria?: Record<string, unknown>;
  columnConfig?: Record<string, unknown>;
}

interface UpdateViewParams {
  orgId: number;
  id: number;
  name?: string;
  description?: string;
  tagId?: number | null;
  searchCriteria?: Record<string, unknown> | null;
  columnConfig?: Record<string, unknown> | null;
}

const viewAPI = base.injectEndpoints({
  endpoints: (build) => ({
    listViews: build.query<View[], number>({
      query: (orgId) => ({
        url: `/v2/bill-views/${orgId}`,
        method: 'GET',
      }),
      providesTags: [{ type: ApiTag.VIEW }],
    }),
    createView: build.mutation<View, CreateViewParams>({
      query: ({ orgId, ...data }) => ({
        url: `/v2/bill-views/${orgId}`,
        method: 'POST',
        data,
      }),
      invalidatesTags: [ApiTag.VIEW],
    }),
    updateView: build.mutation<View, UpdateViewParams>({
      query: ({ orgId, id, ...data }) => ({
        url: `/v2/bill-views/${orgId}/${id}`,
        method: 'PATCH',
        data,
      }),
      invalidatesTags: [ApiTag.VIEW],
    }),
    deleteView: build.mutation<void, { orgId: number; id: number }>({
      query: ({ orgId, id }) => ({
        url: `/v2/bill-views/${orgId}/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: [ApiTag.VIEW],
    }),
  }),
  overrideExisting: false,
});

export default viewAPI;
